import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const GroupDialog = ({ open, onOpenChange, initial, onSave }) => {
  const [name, setName] = useState("");
  useEffect(() => { if (open) setName(initial?.name || ""); }, [open, initial]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="group-form-dialog" className="sm:max-w-sm" aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle className="font-head text-2xl">{initial?.id ? "Rename group" : "New group"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={(e) => { e.preventDefault(); if (name.trim()) onSave(name.trim()); }} className="space-y-4">
          <Input data-testid="group-name-input" placeholder="Group name" value={name} onChange={(e) => setName(e.target.value)} autoFocus />
          <DialogFooter>
            <Button type="submit" disabled={!name.trim()} className="bg-sky-600 hover:bg-sky-700" data-testid="group-save-btn">Save</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
